import React from 'react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { dateFormats } from 'commons/src/constants';
import { BuildingType, DayUsageHours } from 'commons/src/models/commonTypeScript';
import { ReportSectionWrapper } from '../../../components/wrappers';
import styles from './IAQInsight2OpeningHours.module.scss';

export type IAQInsight2OpeningHoursProps = {
    building: BuildingType;
    dateFormat?: keyof typeof dateFormats;
};

const defaultUsageHours = {
    monday: { closed: false },
    tuesday: { closed: false },
    wednesday: { closed: false },
    thursday: { closed: false },
    friday: { closed: false },
    saturday: { closed: false },
    sunday: { closed: false },
};

const IAQInsight2OpeningHours: React.FC<IAQInsight2OpeningHoursProps> = ({ building, dateFormat = 'US' }) => {
    const { t: txt } = useTranslation();

    const usageHours: { [day: string]: DayUsageHours } = {
        ...defaultUsageHours,
        ...(building && building.usageHours),
    };

    return (
        <ReportSectionWrapper>
            <h3 className={styles.headingLargeBold}>{txt('Building.DayScheduleOpeningHours')}</h3>
            <div className={styles.row}>
                {Object.entries(usageHours).map(([day, hours]) => {
                    const formatTime = (time: string): string => {
                        const isUSFormat = dateFormats[dateFormat].hourFormat === 'LT';
                        // dayjs requires a full date-time string; date is arbitrary placeholder, only time is formatted
                        return dayjs(`2000-01-01 ${time}`).format(isUSFormat ? 'h:mm A' : 'HH:mm');
                    };

                    const from = hours.from ? formatTime(hours.from) : '';
                    const to = hours.to ? formatTime(hours.to) : '';

                    return (
                        <div key={day} className={styles.fieldMediumSlim}>
                            <div className={styles.labeledText}>
                                <span className={styles.label}>{day.charAt(0).toUpperCase() + day.slice(1)}</span>
                                <span className={styles.valueLarge}>{hours.closed ? 'Closed' : `${from} - ${to}`}</span>
                            </div>
                        </div>
                    );
                })}
            </div>
        </ReportSectionWrapper>
    );
};

export default IAQInsight2OpeningHours;
